import React from "react";
import {
  Grid,
  createStyles,
  makeStyles,
  Theme,
  Typography,
  Container,
  Box,
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { ReactComponent as PirateIcon } from "../../assets/imgs/icons/pirate.svg";
import { useHistory } from "react-router-dom";

interface IPricingProps {}

const Pricing: React.FC<IPricingProps> = () => {
  const history = useHistory();
  const classes = useStyles();
  return (
    <Container className={classes.container}>
      <Grid container direction="row" justify="center">
        <Grid item className={classes.freeCard} md={3}>
          <Typography className={classes.title}>Base</Typography>
          <Typography className={classes.free}>Free</Typography>
          <Typography>
            Save your findings - fast, traceable and structured
          </Typography>
          <Box mt={7} mb={6}>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.icon} />
              </Grid>
              <Grid item>
                <Typography>Collect findings traceable</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.icon} />
              </Grid>
              <Grid item>
                <Typography>Plugin</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.icon} />
              </Grid>
              <Grid item>
                <Typography>faktual’s smart editor</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.icon} />
              </Grid>
              <Grid item>
                <Typography>Labels</Typography>
              </Grid>
            </Grid>
          </Box>
          <Grid item className={classes.freeButton}>
            <Typography className={classes.freeButtonText}>
              Welcome on board
            </Typography>
            <PirateIcon width={20} height={20} />
          </Grid>
        </Grid>
        <Grid item className={classes.popularCard} md={3}>
          <Typography className={classes.popular}>Popular</Typography>
          <Box display="flex" alignItems="center">
            <Typography className={classes.price}>€8</Typography>
            <Typography className={classes.popular}>/Month</Typography>
          </Box>
          <Typography className={classes.popularText}>
            For users that
          </Typography>
          <Box mt={5} mb={5}>
            <Typography className={classes.popularText}>Base plus</Typography>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconWhite} />
              </Grid>
              <Grid item>
                <Typography className={classes.popularText}>
                  Connect knowledge hubs
                </Typography>
                <img src="images/sources_logos.png" alt="sources" />
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconWhite} />
              </Grid>
              <Grid item>
                <Typography className={classes.popularText}>
                  AI to summarize findings
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconWhite} />
              </Grid>
              <Grid item>
                <Typography className={classes.popularText}>
                  Collaboration
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconWhite} />
              </Grid>
              <Grid item>
                <Typography className={classes.popularText}>
                  Cross-referencing
                </Typography>
              </Grid>
            </Grid>
          </Box>
          <Grid
            item
            className={classes.demoButton}
            onClick={() => history.push("pricing-popular")}
          >
            <Typography className={classes.demoButtonText}>Demo</Typography>
          </Grid>
        </Grid>
        <Grid item className={classes.enterpriseCard} md={3}>
          <Typography className={classes.title}>Enterprise</Typography>
          <Typography className={classes.defined}>Defined together</Typography>
          <Typography>For users that </Typography>
          <Box mt={7} mb={6}>
            <Typography>Popular plus</Typography>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconBlue} />
              </Grid>
              <Grid item>
                <Typography>Connect local databases</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconBlue} />
              </Grid>
              <Grid item>
                <Typography>On-premise</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconBlue} />
              </Grid>
              <Grid item>
                <Typography>Own elastic instance</Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justify="flex-start"
              alignItems="center"
              spacing={2}
            >
              <Grid item>
                <CheckCircleIcon className={classes.iconBlue} />
              </Grid>
              <Grid item>
                <Typography>Employee training</Typography>
              </Grid>
            </Grid>
          </Box>
          <Grid
            item
            className={classes.enterpriseButton}
            onClick={() => history.push("pricing-enterprise")}
          >
            Demo
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: "100px",
      height: "100%",
    },
    freeCard: {
      display: "flex",
      flexDirection: "column",
      margin: theme.spacing(3),
      padding: theme.spacing(2),
    },
    freeButton: {
      // backgroundColor: "#9BCE63",
      border: "2px solid #A7A7A7",
      boxSizing: "border-box",
      borderRadius: "10px",
      height: "56px",
      padding: theme.spacing(2),
      display: "flex",
      justifyContent: "space-between",
    },
    freeButtonText: {
      fontSize: "18px",
      lineHeight: "21px",
      fontWeight: "bold",
      color: "#A7A7A7",
    },
    popularCard: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.palette.primary.main,
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      borderRadius: "10px",
      padding: theme.spacing(2),
      margin: theme.spacing(3),
    },
    demoButton: {
      backgroundColor: "#9BCE63",
      border: "2px solid #9BCE63",
      boxSizing: "border-box",
      borderRadius: "10px",
      height: "56px",
      padding: theme.spacing(2),
      textAlign: "center",
      filter: "drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))",
      cursor: "pointer",
    },
    demoButtonText: {
      fontSize: "20px",
      lineHeight: "23px",
      color: "#FFFFFF",
      fontWeight: "bold",
    },
    enterpriseCard: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "#FFFFFF",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      borderRadius: "10px",
      padding: theme.spacing(2),
      margin: theme.spacing(3),
    },
    enterpriseButton: {
      border: `2px solid ${theme.palette.primary.main}`,
      boxSizing: "border-box",
      borderRadius: "10px",
      height: "56px",
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.primary.main,
      cursor: "pointer",
    },
    title: {
      fontSize: "20px",
      lineHeight: "23px",
    },
    free: {
      fontSize: "50px",
      lineHeight: "59px",
      fontWeight: "bold",
    },
    defined: {
      fontSize: "30px",
      lineHeight: "35px",
      fontWeight: "bold",
      margin: "10px 0",
    },
    icon: {
      fontSize: "15px",
      color: "#A7A7A7",
    },
    iconWhite: {
      fontSize: "15px",
      color: "#FFF",
    },
    iconBlue: {
      fontSize: "15px",
      color: theme.palette.primary.main,
    },
    popular: {
      fontSize: "20px",
      lineHeight: "23px",
      color: "#FFFFFF",
    },
    price: {
      fontSize: "50px",
      lineHeight: "59px",
      fontWeight: "bold",
      color: "#FFFFFF",
      marginRight: theme.spacing(2),
    },
    popularText: {
      color: "#FFFFFF",
    },
  })
);

export default Pricing;
